import { render, staticRenderFns } from "./banckAccountInfo.vue?vue&type=template&id=66d7cec0&scoped=true"
import script from "./banckAccountInfo.vue?vue&type=script&lang=js"
export * from "./banckAccountInfo.vue?vue&type=script&lang=js"
import style0 from "./banckAccountInfo.vue?vue&type=style&index=0&id=66d7cec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d7cec0",
  null
  
)

export default component.exports